import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { AutocompleteBodyshopAndSupplierRequest, CompanyFilterRequest } from "@/main/models/request";

export abstract class ICompanyApi {
	abstract getDomain(request: CompanyFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDomainAll(request: CompanyFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getAutocompleteBodyshopAndSupplier(
		request: AutocompleteBodyshopAndSupplierRequest,
		signal?: AbortSignal,
	): Promise<AxiosResponse<Result<PaginationResponse<KeyValue>>>>;
}
